import { render, staticRenderFns } from "./white-paper-detail.vue?vue&type=template&id=38a995c2&scoped=true"
import script from "./white-paper-detail.vue?vue&type=script&lang=js"
export * from "./white-paper-detail.vue?vue&type=script&lang=js"
import style0 from "./white-paper-detail.vue?vue&type=style&index=0&id=38a995c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a995c2",
  null
  
)

export default component.exports